import React from 'react';
import styled, { css } from 'styled-components';
import { Icon } from '../Icon/Icon';
import { getBlueColors, getNeutralColors, getRedColors } from '../theme';

const Wrapper = styled.div`
  display: flex;
  align-items: flex-start;
  border-radius: 4px;
  margin-bottom: ${({ margin }) => margin || '32px'};
  padding: 12px 16px 12px 0px;
  width: 100%;
  white-space: break-spaces;

  ${({ type }) =>
    type === 'info' &&
    css`
      background-color: ${getNeutralColors('grisClaro')};
      border-left: 4px solid ${getBlueColors('base')};
    `};

  ${({ type }) =>
    type === 'warning' &&
    css`
      background-color: ${getRedColors('light')};
      border-left: 4px solid ${getRedColors('base')};
    `};

  ${({ type }) =>
    type === 'data' &&
    css`
      background-color: ${getNeutralColors('grisClaro')};
      border-left: 4px solid ${getBlueColors('base')};
      margin-bottom: 0;
    `};

  ${({ bg }) =>
    bg &&
    css`
      background-color: ${bg};
    `}

  ${({ maxWidth }) =>
    maxWidth &&
    css`
      max-width: ${maxWidth};
    `}

  justify-items: ${({ icon }) => (!icon ? 'flex-start' : 'space-between')};
`;

const IconWrapper = styled.div`
  height: 16px;
  margin: 3px 9px;
  width: 16px;

  > svg {
    margin: 0px;
  }
`;

const Info = ({ children, alertType = 'info', icon = true, background, maxWidth = '', margin = '' }) => {
  return (
    <Wrapper type={alertType} bg={background} icon={icon} maxWidth={maxWidth} margin={margin}>
      {icon && (
        <IconWrapper>
          <Icon name={alertType === 'info' ? 'alertBlue' : 'alertRed'} />
        </IconWrapper>
      )}
      {children}
    </Wrapper>
  );
};

export { Info };
